export default __webpack_public_path__ + "static/media/imagine-logo-mobile.664b883b.svg";